<template>
  <v-container white>

    <div v-if="commentsInEvaluation.length > 0 || commentToAdd">
      <h3 class="body-2">{{$t('evaluationComment')}}</h3>
      <div v-for="comment in evaluationComments" :key="comment.id" class="mb-3">
        <v-flex xs11 offset-xs1>
          <comment-inline-editor :comment="comment" v-on:commentEvent="updateComment"></comment-inline-editor>
        </v-flex>
      </div>
    </div>

    <div v-if="evaluationComments.length === 0">
      <div v-if="commentToAdd">
        <v-flex xs11 offset-xs1>
          <comment-inline-editor :edit="true" :comment="commentToAdd" v-on:commentEvent="updateComment"></comment-inline-editor>
        </v-flex>
      </div>
      <div v-else class="mb-3">
          <v-layout row justify-space-between>
            <p v-if="commentsInEvaluation.length === 0" class="pt-3 grey--text">
              {{$t('commentListEmpty')}}
            </p>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="addComment">{{$t('addEvaluationComment')}}</v-btn>
          </v-layout>
      </div>
    </div>

    <div v-if="categoryComments.length > 0">    
      <v-divider class="mb-3"></v-divider>

      <h3 class="body-2 mb-3">{{$t('categoryComments')}}</h3>
      <div v-for="comment in categoryComments" :key="comment.id" class="mb-3">
        <div class="caption grey--text text--darken-2">{{(comment.categoryByCategoryId.title)}}</div>
        <v-flex xs11 offset-xs1>
          <comment-inline-editor :comment="comment" v-on:commentEvent="updateComment"></comment-inline-editor>
        </v-flex>
      </div>
    </div>

    <div v-if="indicatorComments.length > 0">
      <v-divider class="mb-3"></v-divider>

      <h3 class="body-2 mb-3">{{$t('indicatorComments')}}</h3>
      <div v-for="comment in indicatorComments" :key="comment.id" pt-2 pb-3>
        <div class="caption grey--text text--darken-2">{{(comment.indicatorByIndicatorId.title)}}</div>
        <v-flex xs11 offset-xs1>
          <comment-inline-editor :comment="comment" v-on:commentEvent="updateComment"></comment-inline-editor>
        </v-flex>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
</style>

<script>
import CommentInlineEditor from '@/components/CommentInlineEditor.vue'
export default {
  props: ['evaluationId', 'currentUser', 'commentsInEvaluation'],
  data() { return { 
    commentToAdd: null
  }},
  components: { CommentInlineEditor },
  methods: {
    addComment() {
      this.commentToAdd = {
        evaluationId: this.evaluationId,
        userId: this.currentUser.id,
        content: ''
      }
    },
    updateComment() {
      if (this.commentToAdd) {
        this.commentToAdd = null
      }
      this.$emit('commentEvent')
    },
  },
  computed: {
    evaluationComments(){
      var evaluationComments = []
      for(var comment of this.commentsInEvaluation){
        if(comment &&
          !comment.participantByParticipantId &&
          !comment.categoryByCategoryId &&
          !comment.indicatorByIndicatorId
        ){
          evaluationComments.push(comment)
        }
      }
      return evaluationComments
    },
    categoryComments(){
      var categoryComments = []
      for(var comment of this.commentsInEvaluation){
        if(comment &&
          comment.categoryByCategoryId &&
          !comment.indicatorByIndicatorId
        ){
          categoryComments.push(comment)
        }
      }
      return categoryComments
    },
    indicatorComments(){
      var indicatorComments = []
      for(var comment of this.commentsInEvaluation){
        if(comment &&
          !comment.categoryByCategoryId &&
          comment.indicatorByIndicatorId
        ){
          indicatorComments.push(comment)
        }
      }
      return indicatorComments
    }
  },
}
</script>